import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

const Dashboard = () => {
  const [stocktakes, setStocktakes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { store, accountStore, loading: authLoading, viewMode } = useAuth();

  useEffect(() => {
    fetchStocktakes();
  }, []);

  const fetchStocktakes = async () => {
    try {
      const response = await api.get('/stocktakes');
      setStocktakes(response.data.stocktakes);
    } catch (err) {
      setError('Failed to load stocktakes');
    } finally {
      setLoading(false);
    }
  };

  const createNewStocktake = async () => {
    try {
      const name = prompt('Enter stocktake name (optional):');
      const response = await api.post('/stocktakes', { 
        name: name || `Stocktake ${new Date().toLocaleString()}` 
      });
      navigate(`/stocktake/${response.data.stocktakeId}`);
    } catch (err) {
      alert('Failed to create stocktake');
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString();
  };

  return (
    <div className="container">
      <div className="card">
        <div className="card-header">
          <h2 className="card-title">Dashboard</h2>
          <button 
            className="btn btn-primary btn-small" 
            onClick={createNewStocktake}
            style={{ width: 'auto', flex: '0 0 auto' }}
          >
            New Stocktake
          </button>
        </div>

        <div className="flex gap-2 mb-3">
          {!authLoading && accountStore && (accountStore.role === 'app_admin' || accountStore.role === 'business_admin') && viewMode !== 'site' && (
            <button
              className="btn btn-secondary btn-small"
              onClick={() => navigate('/admin')}
            >
              Admin Panel
            </button>
          )}
          <button 
            className="btn btn-secondary btn-small"
            onClick={() => navigate('/manage-items')}
          >
            Manage Stock Items
          </button>
          <button 
            className="btn btn-secondary btn-small"
            onClick={() => navigate('/manage-area-items')}
          >
            Assign Items to Areas
          </button>
          <button 
            className="btn btn-secondary btn-small"
            onClick={() => navigate('/manage-areas')}
          >
            Manage Stock Areas
          </button>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        {loading ? (
          <div className="loading">
            <div className="spinner"></div>
          </div>
        ) : (
          <>
            <h3 className="mb-2">Recent Stocktakes</h3>
            {stocktakes.length === 0 ? (
              <div className="text-center" style={{ padding: '2rem', color: 'var(--text-light)' }}>
                No stocktakes yet. Click "New Stocktake" to get started!
              </div>
            ) : (
              <div>
                {stocktakes.map((stocktake) => (
                  <div key={stocktake.id} className="list-item">
                    <div className="list-item-content">
                      <div className="list-item-title">{stocktake.name}</div>
                      <div className="list-item-subtitle">
                        Started: {formatDate(stocktake.started_at)}
                        {stocktake.completed_at && ` • Completed: ${formatDate(stocktake.completed_at)}`}
                      </div>
                    </div>
                    <div className="list-item-actions">
                      {stocktake.status === 'completed' ? (
                        <button
                          className="btn btn-secondary btn-small"
                          onClick={() => navigate(`/stocktake/${stocktake.id}/report`)}
                        >
                          View Report
                        </button>
                      ) : (
                        <button
                          className="btn btn-primary btn-small"
                          onClick={() => navigate(`/stocktake/${stocktake.id}`)}
                        >
                          Continue
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
